module.exports = __webpack_public_path__ + "04dd2bb4d8a3f09cdd8a32301cff7fe4.fbx";